<template>
  <v-row no-gutters>
    <v-col
      md="8"
      offset-md="2">
      <v-container class="page page--form">
        <ValidationObserver
          ref="obs"
          v-slot="{ valid, handleSubmit }">
          <v-form
            v-model="valid"
            @submit.prevent="handleSubmit(onSubmit)">
            <validation-input
              v-model="account.account_name"
              rules="required|min:3|max:255"
              label="Nom du compte *" />
            <validation-select
              v-model="account.account_type"
              :items="accountTypes"
              item-text="text"
              item-value="value"
              required
              label="Compte *"
              rules="required" />
            <validation-select
              v-model="account.plan"
              :items="availablePlans"
              item-text="name"
              item-value="pk"
              required
              label="Abonnement *"
              rules="required" />
            <v-radio-group v-model="admin.title">
              <v-radio
                key="mme"
                label="Madame"
                value="mme" />
              <v-radio
                key="m"
                label="Monsieur"
                value="m" />
            </v-radio-group>
            <validation-input
              v-model="admin.first_name"
              rules="required|min:3|max:255"
              label="Prénom de l'admin *" />
            <validation-input
              v-model="admin.last_name"
              rules="required|min:3|max:255"
              label="Nom de l'admin *" />
            <validation-input
              v-model="admin.email"
              rules="required|email"
              type="email"
              label="Email de l'admin *" />
            <validation-input
              v-model="admin.phone"
              rules="required|min:10|max:13"
              label="Téléphone de l'admin *" />
            <address-input @update="updateAddress" />
            <v-row>
              <v-col
                v-for="(user,index) in users"
                :key="index"
                md="6"
                lg="6"
                sm="6">
                <v-card shaped>
                  <v-card-title>Utilisateur</v-card-title>
                  <v-card-text>
                    <v-radio-group v-model="user.title">
                      <v-radio
                        key="mme"
                        label="Madame"
                        value="mme" />
                      <v-radio
                        key="m"
                        label="Monsieur"
                        value="m" />
                    </v-radio-group>
                    <validation-input
                      v-model="user.first_name"
                      rules="required|min:3|max:255"
                      label="Prénom *" />
                    <validation-input
                      v-model="user.last_name"
                      rules="required|min:3|max:255"
                      label="Nom* " />
                    <validation-input
                      v-model="user.email"
                      rules="required|email"
                      type="email"
                      label="Email *" />
                    <validation-input
                      v-model="user.phone"
                      rules="required|min:10|max:13"
                      label="Téléphone *" />
                    <validation-select
                      v-model="user.profil"
                      :items="availableProfils"
                      item-text="text"
                      item-value="value"
                      required
                      label="Profil *"
                      rules="required" />
                    <v-card-actions>
                      <v-btn
                        text
                        type="button"
                        color="red"
                        @click="removeUser(index)">
                        Supprimer
                      </v-btn>
                    </v-card-actions>
                  </v-card-text>
                </v-card>
              </v-col>
            </v-row>
            <v-btn
              type="submit"
              color="success"
              class="mr-4">
              Valider
            </v-btn>
            <v-btn
              type="button"
              color="secondary"
              outlined
              @click="addUserInputs">
              Ajouter un utilisateur
            </v-btn>
          </v-form>
        </ValidationObserver>
      </v-container>
    </v-col>
  </v-row>
</template>

<script>
  import RESOURCES from '@batimentb/vadimm-js-api/resources'
  import { isNil } from 'lodash'

  export default {
    name: 'NewAccount',
    data () {
      return {
        availableProfils: [
          {
            'value': 'seller',
            'text': 'Vendeur'
          },
          {
            'value': 'manager',
            'text': 'Manager'
          },
          {
            'value': 'admin',
            'text': 'Admin'
          }
        ],
        accountTypes: [
          {
            'value': 'promoteur',
            'text': 'Promoteur'
          },
          {
            'value': 'commercial',
            'text': 'CGP/Distributeur'
          }
        ],
        isLoading: false,
        plans: [],
        account: {
          plan: null,
          account_type: null,
          account_name: null
        },
        address: null,
        admin: {
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          profil: 'admin'
        },
        users: [{
          title: null,
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          profil: null
        }, {
          title: null,
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          profil: null
        }]
      }
    },
    computed: {
      availablePlans () {
        if (this.account.account_type && this.plans && this.plans.length > 0) {
          return this.plans.filter(x => x.account_type === this.account.account_type)
        }
        return []
      },
      addressIsValid () {
        return isNil(this.address) === false || (this.address.line1 && this.address.zip_code)
      }
    },
    created () {
      this.fetchPlans()
    },
    methods: {
      updateAddress (value) {
        this.$set(this, 'address', value)
      },
      addUserInputs () {
        this.users.push({
          first_name: null,
          last_name: null,
          email: null,
          phone: null,
          profil: null
        })
      },
      removeUser (index) {
        this.users.splice(index, 1)
      },
      async fetchPlans () {
        this.isLoading = true
        let request = await this.$api.get(RESOURCES.PLAN)
        this.plans = request.data.items
        this.isLoading = false
      },
      async onSubmit () {
        if (!this.addressIsValid) {
          return
        }
        const payload = Object.assign({}, this.account)
        payload.admin = this.admin
        payload.users = this.users
        payload.address = this.address
        try {
          await this.$api.post(RESOURCES.ACCOUNT, payload)
          this.$awn.success('Compte créé')
          await this.$router.replace({ name: 'accounts' })
        } catch (e) {
          this.$awn.warning('Erreur lors de la création')
        }
      }
    }
  }
</script>

<style scoped>

</style>
